import { BillingType } from '@gelato-api-ui/core/clients/billing-type.enum';
import { ShippingPriceType } from '@gelato-api-ui/core/clients/shipping-price-type.enum';
import { Question } from '@gelato-api-ui/core/quick-questions/types/question';

export class CompanyDetails {
  constructor(
    public companyName: string = '',
    public companyNumber: string = '',
    public companyVatNumber: string = '',
    public companyVatNumbers: string[] = [],
    public recipientName: string = '',
    public address: string = '',
    public city: string = '',
    public postCode: string = '',
    public stateCode: string = '',
    public countryIsoCode: string = '',
    public email: string = '',
    public contactEmail: string = '',
    public billingEmail: string = '',
    public supportEmail: string = '',
    public phone: string = '',
    public currency: string = '',
    public billingType: BillingType = null,
    public shippingPriceType: ShippingPriceType = null,
    public questionnaire: Question[] = null,
    public clientId: string = null,
    public createdAt: number = null,
  ) {}
}
